import { gql, TypedDocumentNode } from 'apollo-angular';

import { ISubscriptionRoomMessageCreatedRes } from '@shared/models/messages';
import { ROOM_MESSAGE_FRAGMENT } from '@graphql/queries/messages.queries';

export const ROOM_MESSAGE_CREATED_SUBSCRIPTION: TypedDocumentNode<ISubscriptionRoomMessageCreatedRes> = gql`
  subscription roomMessageCreated {
    roomMessageCreated {
      created {
        ...RoomMessageFragment
      }
    }
  }
  ${ROOM_MESSAGE_FRAGMENT}
`;
